import { createSlice } from "@reduxjs/toolkit";
import { externalTrafficOptions } from "root/utils/socialNetworks/bloggers";

import { bloggersPostsSelectionParamsForRedux } from "../../pages/bloggers_posts_selection/data";

export const bloggersPostsParams = {
  source: [],
  brand_id: [],
  account_name_hash: [],
  subject: [],
  product_id: [],
  valueble: externalTrafficOptions[0].id,
  before_out_of_stock: "",
  after_out_of_stock: "",
  subscriber_count__gte: "",
  subscriber_count__lte: "",
  success_level__gte: "",
  success_level__lte: "",
  mapped_article__not_null: "",
  ...bloggersPostsSelectionParamsForRedux,
};

const initialState = {
  params: {
    ...bloggersPostsParams,
  },
  ordering: "-w_proceeds",
};

const bloggersPosts = createSlice({
  name: "bloggersPosts",
  initialState,
  reducers: {
    // setSocialNetworks(state, { payload: newSN = [] }) {
    //   state.params.source = newSN;
    // },
    setBloggersPostsParamByName(state, { payload: { value, name } }) {
      state.params[name] = value;
    },
    setBloggersPostsParams(state, { payload: savedParams }) {
      state.params = savedParams;
    },
    resetBloggersPostsFilters(state) {
      state.params = bloggersPostsParams;
    },
    setBloggersPostsOrdering(state, { payload: value }) {
      state.ordering = value;
    },
  },
});

export default bloggersPosts.reducer;
export const {
  setBloggersPostsParamByName,
  setBloggersPostsParams,
  resetBloggersPostsFilters,
  setBloggersPostsOrdering,
} = bloggersPosts.actions;
